import gql from 'graphql-tag'

export const GET_STUDENT_LANGUAGE_MATERIALS = gql`
  query StudentLanguageMaterials($StudentProfileId: String!, $Language: String!) {
    getStudentLanguageMaterials(StudentProfileId: $StudentProfileId, Language: $Language) {
      StudentProfileName
      StudentProfileId
      StudentLanguageProfileLanguage
      StudentLanguageProfileId
      Status
      SkillsTutorCompleted
      RecordId
      Name
      MaterialName
      MaterialLPID
      MaterialId
      IsSkillsTutorMaterial
    }
  }
`
